<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    import Analytics from "@/util/analytics";
    import router from "@/router";
    export default {

        name: "App",
        data() {
            return {}
        },
        created() {
            router.afterEach((to, from) => {
                const toPage = to.name;
                const fromPage = from.name;

                const EXCLUDED_PAGES = ['OrderList'];
                const SPECIAL_PAGES = ['MealInfo', 'TicketDetail'];
                const DETAIL_PAGES = ['ArticleDetail', 'MealInfo', 'TicketDetail'];
                const SHOPPING_AREA_DETAIL_PAGES = ['MarketplaceArticleDetail', 'MarketplaceActivityDetail'];
                const SHOPPING_AREA_STALL_PAGES = 'StallInfo';

                const fromInstance = Analytics.getInstanceByPage(fromPage);

                if (fromPage && fromInstance) {
                    const metadata = fromInstance.getLeavePageMetadata();
                    fromInstance.sendEvent(Analytics.EVENTS.LEAVE_PAGE, metadata);
                }

                const path = to.path;
                if (SPECIAL_PAGES.includes(toPage) && fromPage === "StoreInfo") {
                    Analytics.handleStoreToken(from);
                } else {
                    let stallId = 0;
                    if (toPage === SHOPPING_AREA_STALL_PAGES) {
                        stallId = Number(this.$crypto.uriComponentToObject(this.$route.query.dataToken)?.id ?? 0);
                    }
                    Analytics.handleShoppingArea({path: path, stallId: stallId});
                    Analytics.handleStoreToken(to);
                }

                if (fromPage && !EXCLUDED_PAGES.includes(fromPage)) {
                    Analytics.destroyInstance(fromPage, fromPage);
                }

                if (toPage && !EXCLUDED_PAGES.includes(toPage)) {
                    let analytics = Analytics.getInstance(to, toPage, fromPage);
                    if (DETAIL_PAGES.includes(toPage)) {
                        let itemId;
                        if (to.query.id) {
                            itemId = to.query.id
                        } else if (to.query.mealId) {
                            itemId = to.query.mealId;
                        } else {
                            itemId = this.$crypto.decryptObjectText(to.query.p).id;
                        }

                        analytics.sendEvent(Analytics.EVENTS.VIEW_ITEM, {itemId: itemId});
                    } else if (SHOPPING_AREA_DETAIL_PAGES.includes(toPage)) {
                        let code;
                        if (to.query.code) {
                            code = to.query.code;
                        }

                        analytics.sendEvent(Analytics.EVENTS.VIEW_ITEM, {code: code});
                    }
                }
            });
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
